{% block topdata_contact_login_detail_details %}
<sw-card
    class="topdata-contact-login-detail-details__master-data-card"
    :title="$tc('TopdataContactLoginSW6.contactList.detail.card.masterData')"
    :isLoading="isLoading"
>
    <template #toolbar>
        <sw-button-process
            class="topdata-contact-login-detail-details__save-button"
            :is-loading="isSaving"
            :process-success="isSaveSuccessful"
            variant="primary"
            @update:process-success="isSaveSuccessful = false"
            @click="onSave"
        >
            {{ $tc('global.default.save') }}
        </sw-button-process>
    </template>

    <sw-container
        columns="1fr 1fr"
        gap="16px"
    >
        <sw-text-field
            v-model="contact.email"
            :label="$tc('TopdataContactLoginSW6.admin.email')"
            :error="contactEmailError"
        />

        <sw-password-field
            v-model="contact.password"
            :label="$tc('TopdataContactLoginSW6.admin.password')"
            :helpText="$tc('TopdataContactLoginSW6.admin.passwordHelp')"
        />
    </sw-container>

    <sw-select-field
        v-model="contact.salutationId"
        :label="$tc('sw-customer.baseForm.labelSalutation')"
        :options="salutationOptions"
        :placeholder="$tc('TopdataContactLoginSW6.admin.noAddress')"
    />

    <sw-container
        columns="1fr 1fr"
        gap="16px"
    >
        <sw-text-field
            v-model="contact.firstName"
            :label="$tc('TopdataContactLoginSW6.admin.firstName')"
        />

        <sw-text-field
            v-model="contact.lastName"
            :label="$tc('TopdataContactLoginSW6.admin.lastName')"
        />
    </sw-container>

    <sw-switch-field
        v-model:value="contact.active"
        :label="$tc('TopdataContactLoginSW6.admin.active')"
    />
</sw-card>

<sw-card
    class="topdata-contact-login-detail-details__customer-card"
    :title="$tc('TopdataContactLoginSW6.contactList.detail.card.customerInfo')"
    :isLoading="isLoading"
>
    <sw-description-list>
        <dt>{{ $tc('TopdataContactLoginSW6.contactList.list.column.customer') }}</dt>
        <dd>
            <a
                v-if="contact.customer"
                class="topdata-contact-login-detail-details__customer-link"
                @click.prevent="openCustomer"
            >
                {{ getCustomerLabel() }}
            </a>
            <span v-else>—</span>
        </dd>

        <dt>{{ $tc('TopdataContactLoginSW6.contactList.detail.label.createdAt') }}</dt>
        <dd>
            <sw-time-ago
                v-if="contact.createdAt"
                :date="contact.createdAt"
                :date-time-format="{ month: '2-digit', day: '2-digit' }"
            />
        </dd>
    </sw-description-list>

    <sw-select-field
        v-model="contact.defaultBillingAddressId"
        :label="$tc('TopdataContactLoginSW6.admin.defaultBillingAddress')"
        :options="addressOptions"
        :placeholder="$tc('TopdataContactLoginSW6.admin.selectAddress')"
    />

    <sw-select-field
        v-model="contact.defaultShippingAddressId"
        :label="$tc('TopdataContactLoginSW6.admin.defaultShippingAddress')"
        :options="addressOptions"
        :placeholder="$tc('TopdataContactLoginSW6.admin.selectAddress')"
    />
</sw-card>
{% endblock %}
